import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import UserDatabases from '@Services/UserDatabases';
import {
  casNumberLoading as casNumberLoadingSelector,
  casNumberError as casNumberErrorSelector,
  casNumber as casNumberSelector,
  casNumberStateByResultName as casNumberStateByResultNameSelector,
} from '@Containers/CasNumber/selectors';
import { fetchCasNumber } from '@Containers/CasNumber/actions';
import CasNumber from '@Containers/CasNumber/CasNumber';
import isArray from 'lodash/isArray';

export const isCasNumberAllowed = (databaseId) =>
  UserDatabases.isDefaultDatabase(databaseId) || UserDatabases.isRCSDatabase(databaseId) || UserDatabases.isPUDatabase(databaseId);

function CasNumberContainer(props) {
  const { databaseId } = props;

  return isCasNumberAllowed(databaseId) ? <CasNumber {...props} /> : null;
}

CasNumberContainer.propTypes = {
  databaseId: PropTypes.string,
};

function mapStateToProps(state, ownProps) {
  const { casRegistryNumbers, inChiKey, name, structure } = ownProps;
  const isCasNumberRetrievable = !!((structure && inChiKey) || (!structure && name));
  const casNumberFromReaxys = isArray(casRegistryNumbers) ? casRegistryNumbers.join(', ') : casRegistryNumbers;
  const casNumberFromApi = casNumberSelector(state, ownProps);
  const casNumber = casNumberFromReaxys || casNumberFromApi;
  const fromCasApi = !casNumberFromReaxys && !!casNumberFromApi;
  const isFromCasSearch = !!casNumberStateByResultNameSelector(state, ownProps);

  return {
    casNumberLoading: casNumberLoadingSelector(state, ownProps),
    casNumberError: casNumberErrorSelector(state, ownProps),
    casNumber,
    fromCasApi,
    isCasNumberRetrievable,
    isFromCasSearch,
  };
}

const mapDispatchToProps = {
  fetchCasNumber,
};

export default connect(mapStateToProps, mapDispatchToProps)(CasNumberContainer);
